module.exports = __webpack_public_path__ + "b82c6711e5bbe3870ebb92182ae1617e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorWHITEWINE.jpg
// module id = 1125
// module chunks = 1